import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { TAdaptiveStyles } from '.';

interface ICustomStyles {
    customStyles?: TAdaptiveStyles,
}

interface IPopupProps extends ICustomStyles {
    width?: string,
    height?: string,
    fullWidth?: boolean,
    color?: string,
    backgroundColor?: string,
    maxHeight?: string,
}

export const Popup = styled.div<IPopupProps>`
    position: relative;
    display: block;
    cursor: auto;
    opacity: 0;
    transform: translate3d(0, -100vh, 0);
    will-change: transform, opacity;
    animation: slideInBottom 0.35s both 0.15s;
    min-height: 100px;
    min-width: 200px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    width: ${props => props.width ? props.width : '600px'};
    height: ${props => props.height ? props.height : 'auto'};
    max-width: ${props => props.fullWidth ? '100%' : '95%'};
    background: ${props => props.color ? props.color : COLORS.BgMain};
    margin: 32px auto;
    overflow: ${props => props.fullWidth ? 'auto' : 'initial'};
    overflow-y: auto;
    ${props => props?.customStyles?.default || ''};

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: ${props => props.width ? props.width : 'calc(100% - 32px)'};
        height: ${props => props.height ? props.height : 'auto'};
        max-height: ${props => props.maxHeight ? props.maxHeight : 'calc(100% - 32px)'};
        ${props => props?.customStyles?.mobile || ''};
    }

    @keyframes slideInBottom {
        0% {
            transform: translate3d(0, -100vh, 0);
            opacity: 0;
        }
        100% {
            transform: translate3d(0, 0, 0);
            opacity: 1;
        }
    }
`;

export const ClosePopup = styled(Button)<ICustomStyles>`
    z-index: 100;
    position: absolute;
    top: 32px;
    right: 32px;
    width: 36px;
    height: 36px;
    ${props => props?.customStyles?.default ?? ''};

    @media (max-width: ${wideBreakpoints.mobile}) {
        top: 24px;
        right: 24px;
        ${props => props?.customStyles?.mobile ?? ''};
    }
`;
